import {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import jsQR from 'jsqr';


import QrReader from '../components/rts/QrReader/QrReader';
import QrScanResult from '../components/rts/QrReader/QrScanResult';


export default function QrScanPage( props ) {
    //console.debug("RTS Break QrScanPage");

    const history = useNavigate();

    const [showInvalidQRModal, setShowInvalidQRModal] = useState(false);

    const [qrFound, setQrFound] = useState(false);
    const [qrSerial, setQrSerial] = useState();
        

    useEffect(() => {
        props.setIsModalFx(true);
    }, [props]); 

    
    function onScan(imageSrc){
        if (imageSrc) {
            const image = new Image();
            image.src = imageSrc;
            image.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = image.width;
                canvas.height = image.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const code = jsQR(imageData.data, imageData.width, imageData.height, { inversionAttempts: "dontInvert"});
                if (code) {
                    let curData = code?.data;
                    if(curData.length > 0){
                        let curQr = curData.substr(curData.indexOf("-")+1);

                        if(!isNaN(Number(curQr))){
                            setQrFound(true);
                            setQrSerial(curQr);
                        }
                        else{
                            setShowInvalidQRModal(true);
                        }

                    }
                }
            }
        }        
    }


    function handleCancel(e){
        e.preventDefault();
        history(-1);
    }


    return(
        <>
        <Dialog fullWidth={true} maxWidth="sm" open={showInvalidQRModal}>
            <DialogTitle>Invalid Scan</DialogTitle>
            <DialogContent>
                <Typography>The QR Code being scanned does not appear to be valid for Reel Tracking.</Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowInvalidQRModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Container maxWidth="xs">
            <Box sx={{marginTop: 2}}>
                {
                    qrFound===false
                    ?
                    <Box>
                        <Box sx={{display:'flex', justifyContent:'center'}}>
                            <Typography>Place the QR code within the below box</Typography>
                        </Box>
                        <Box sx={{display:'flex', justifyContent:'center'}}>
                            <Box sx={{width:'300px', height:'300px', border:'2px solid black'}}>
                                <QrReader onScan={onScan} />
                            </Box>
                        </Box>
                    </Box>
                :                 
                    <QrScanResult qrSerial={qrSerial} setQrFoundFx={setQrFound}/>
                }                

                <Box sx={{textAlign:'center', mt:3}}>
                    <Button variant="contained" onClick={handleCancel}>
                        Cancel
                    </Button>
                </Box>                
            </Box>
        </Container>
        </>
    );
}
